import Highcharts from "highcharts";
import { linear as linearRegression } from "regression";
/**
 * Add a linear regression trend line to each line-like series in the chart.
 */
export default function addTrendSeries(series) {
    return series.concat(series
        .filter((series) => {
        // Only add trend lines to line-like series
        return series.type && ["line", "spline", "areaspline"].includes(series.type);
    })
        .map((series) => {
        // The linear regression function works better with zero-indexed data, so we first
        // convert the time series data to [i, y] pairs.
        const dataForRegression = series.data.map((datum, index) => [index, datum.y]);
        const regressionResult = linearRegression(dataForRegression);
        // Shove the original timestamps back into the regression data
        return Object.assign(Object.assign({}, series), { type: "line", name: `${series.name} Trend`, color: series.color ? new Highcharts.Color(series.color).setOpacity(1).get() : undefined, lineWidth: 1, dashStyle: "LongDash", data: regressionResult.points.map((point, i) => ({
                x: series.data[i].x,
                y: point[1],
            })) });
    }));
}
